import {
    InternalBannersEditData,
    InternalPlaceTemplates,
    InternalTemplateResources
} from '../../../typings/internalBanners';

export const UPDATE_INTERNAL_BANNERS_FOR_EDIT = 'UPDATE_INTERNAL_BANNERS_FOR_EDIT';
export type UPDATE_INTERNAL_BANNERS_FOR_EDIT = typeof UPDATE_INTERNAL_BANNERS_FOR_EDIT;

export interface UpdateInternalBannersForEdit {
    type: UPDATE_INTERNAL_BANNERS_FOR_EDIT;
    data: InternalBannersEditData;
    placeTemplates: InternalPlaceTemplates;
    templateResources: InternalTemplateResources;
}

export function updateInternalBannersForEditAction(
    data: InternalBannersEditData,
    placeTemplates: InternalPlaceTemplates,
    templateResources: InternalTemplateResources
): UpdateInternalBannersForEdit {
    return {
        type: UPDATE_INTERNAL_BANNERS_FOR_EDIT,
        data,
        placeTemplates,
        templateResources
    };
}
